import {
  Box,
  Button,
  CircularProgress,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { CaretDown, X } from "phosphor-react";
import React, { useEffect, useState } from "react";
import { exportFileWithXhr, fget, fpost } from "../../../API/callsAPI";
import ErrorOrSuccessMessage from "../ErrorOrSuccessMessage/ErrorOrSuccessMessage.component";

const MoveReviewVersionToShotModal = ({
  projectId,
  selectedVersion,
  handleClose,
  isBulkMove,
}) => {
  const [sequenceList, setSequenceList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedSequence, setSelectedSequence] = useState("");
  const [shotName, setShotName] = useState("");
  const [creating, setCreating] = useState(false);
  const [signedUrl, setSignedUrl] = useState("");
  const [shotStatusList, setShotStatusList] = useState([]);
  const [snackValue, setSnackValue] = React.useState({
    isOpen: false,
    message: "",
    isError: false,
  });

  useEffect(() => {
    async function fetchShotsStatusList() {
      const url = `/trackables/status-list/${14}/?project=${projectId}`;
      try {
        const res = await fget({
          url: url,
        });
        setShotStatusList(res?.data?.results || []);
      } catch (error) {
        console.log("error", error);
      }
    }
    fetchShotsStatusList();
  }, []);

  // Fetch sequences
  const fetchFilteredSequence = async () => {
    setLoading(true);

    try {
      const url = `trackables/shot-sequence/?page=1&project=${projectId}`;
      const res = await fget({ url });

      setSequenceList(res?.data?.results || []);
    } catch (err) {
      console.log("Sequence fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  // Create Shot Version
  const createDefaultShotVersion = async (data) => {
    // STEP 1: Download file from selectedVersion.file
    const downloadedFile = await downloadFile(signedUrl);
    const fileName = selectedVersion.file.split("/").pop();

    let formData = new FormData();
    formData.append("name", `${data?.code}.v001`);
    formData.append("shot", data?.id);
    formData.append("file_name", fileName); // 🔥 added as requested

    try {
      const res = await fpost({
        url: "trackables/shot-version/",
        data: formData,
      });
      // STEP 3: Upload downloaded file to signed URL
      await getSignedUrl(res?.data?.id, "shotversion", downloadedFile);
      setSnackValue({
        isOpen: true,
        message: `Successfully Created shot version`,
        isError: false,
      });
      handleClose();
    } catch (error) {
      console.log("Create version error:", error);
    }
  };

  const fetchFile = async (id) => {
    try {
      const fetchFileRes = await fget({
        url: `reviewversion/${id}/file`,
      });
      setSignedUrl(fetchFileRes.data.signed_url);
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: `Failed to fetch file URL`,
        isError: true,
      });
      console.log(error);
    }
  };
  // -----------------------
  // 1️⃣ Convert remote URL → Blob
  // -----------------------
  const downloadFile = async (fileUrl) => {
    const response = await fetch(fileUrl);

    const blob = await response.blob();
    const fileName = fileUrl.split("/").pop();

    return new File([blob], fileName, { type: blob.type });
  };

  function transferComplete(evt) {
    setSnackValue({
      isOpen: true,
      message: `File transfered SuccessFully `,
      isError: false,
    });
  }

  function transferFailed(evt) {
    setSnackValue({
      isOpen: true,
      message: `Transfer Failed`,
      isError: true,
    });
  }

  function transferCanceled(evt) {
    setSnackValue({
      isOpen: true,
      message: `File Transfer Cancelled`,
      isError: true,
    });
  }

  function updateProgressBar(e) {
    if (e.lengthComputable) {
      var percentComplete = parseInt((e.loaded / e.total) * 100);
      // setUploadProgress(percentComplete);
      console.log(percentComplete);
    }
  }

  const getSignedUrl = async (newId, trackable, fileToUpload) => {
    try {
      const res = await fget({
        url: `trackables/${trackable}/${newId}/upload`,
      });

      if (res.status === 200) {
        await exportFileWithXhr({
          url: res.data?.signed_url,
          data: fileToUpload, // 🔥 using downloaded file
          updateProgressBar: (e) => {
            updateProgressBar(e);
          },
          transferComplete: transferComplete(),
          transferFailed: transferFailed(),
          transferCanceled: transferCanceled(),
        });

        // Refresh thumbnail after upload
        await fget({
          url: `trackables/${trackable}/${newId}/thumbnail`,
        });

        // setLoader(false);
        setSnackValue({
          isOpen: true,
          message: `Successfully Created`,
          isError: false,
        });
      }
    } catch (error) {
      // setLoader(false);
      // setFileUploading(false);
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
    }
  };

  // Create Shot
  const createShot = async () => {
    if (!selectedSequence) return alert("Please select a sequence first.");
    if (!shotName.trim()) return alert("Please enter a shot name.");
    if (!selectedVersion?.file)
      return alert("No source file found in selected version.");

    setCreating(true);

    try {
      let formData = new FormData();
      formData.append("code", shotName.trim());
      formData.append("file_path", "");
      formData.append("project", projectId);
      formData.append("parent_sequence", selectedSequence);
      formData.append("vp_linked_level_sequence", "");
      if (
        shotStatusList?.length &&
        (selectedVersion?.status?.toLowerCase() === "approved" ||
          selectedVersion?.status?.toLowerCase() === "rejected")
      ) {
        const approvedStatus = shotStatusList.find(
          (status) =>
            status.name.toLowerCase() === "approved" ||
            status.name.toLowerCase() === "rejected"
        );
        if (approvedStatus) {
          formData.append("status", approvedStatus.id);
        }
      }

      // STEP 2: Create shot in backend
      const res = await fpost({
        url: "trackables/shot/",
        data: formData,
      });

      if (res?.status === 200 || res?.status === 201) {
        setSnackValue({
          isOpen: true,
          message: `Successfully Created shot`,
          isError: false,
        });
        await createDefaultShotVersion(res.data);
      }
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: `shot name is already exist`,
        isError: true,
      });
      setCreating(false);
    }
  };

  const handleBulkMove = async () => {
    try {
      console.log("call");
      const postData = {
        url: `/queue-review-versions-export/`,
        data: {
          sequence: selectedSequence,
          review_versions: selectedVersion?.map((sin) => sin.id),
          shot_code: shotName,
        },
      };
      const res = await fpost(postData);
      handleClose();
      console.log(res);

      console.log(postData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setShotName(selectedVersion?.name || "");
  }, [selectedVersion]);

  useEffect(() => {
    fetchFile(selectedVersion.id);
    if (projectId) fetchFilteredSequence();
  }, [projectId]);

  return (
    <Box
      sx={{
        width: "500px",
        background: "#1B1D28",
        boxShadow: "0px 19px 45px rgba(0,0,0,0.12)",
        borderRadius: "20px",
        padding: "32px 36px",
        display: "flex",
        flexDirection: "column",
        gap: "32px",
        color: "#F9F9F9",
        fontFamily: "Poppins",
      }}
    >
      <ErrorOrSuccessMessage snackValue={snackValue} />

      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: "24px",
            fontWeight: 500,
            lineHeight: "36px",
          }}
        >
          Move to Sequence
        </Typography>

        <Button
          onClick={handleClose}
          sx={{
            minWidth: 0,
            padding: 0,
            color: "#F9F9F9",
          }}
        >
          <X size={32} />
        </Button>
      </Box>

      {/* Content */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          width: "100%",
        }}
      >
        {/* Description */}
        <Typography
          sx={{
            fontSize: "12px",
            lineHeight: "18px",
            color: "#B1B5C9",
          }}
        >
          The chosen versions will be transferred to the selected sequence as
          separate shots with their metadata
        </Typography>

        {/* Versions Selected */}
        {isBulkMove && (
          <Box
            sx={{
              background: "#252A38",
              borderRadius: "5px",
              padding: "0 16px",
              height: "37px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography sx={{ fontSize: "14px" }}>Versions Selected</Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
              {selectedVersion?.length || 0}
            </Typography>
          </Box>
        )}

        {/* Dropdown Label */}
        <Typography
          sx={{
            fontSize: "14px",
            color: "#606479",
          }}
        >
          Select Sequence
        </Typography>

        {/* Sequence Dropdown */}
        {loading ? (
          <CircularProgress size={24} />
        ) : (
          <Select
            fullWidth
            value={selectedSequence}
            onChange={(e) => setSelectedSequence(e.target.value)}
            displayEmpty
            IconComponent={CaretDown}
            sx={{
              height: "41px",
              background: "#252A38",
              borderRadius: "10px",

              "& .MuiSelect-select": {
                padding: "10px 8px 10px 10px",
                fontSize: "14px",
                color: "#F9F9F9",
                display: "flex",
                alignItems: "center",
              },

              "& fieldset": {
                border: "none",
              },

              "& svg": {
                color: "#F9F9F9",
                fontSize: "14px",
                right: "8px",
              },
            }}
          >
            <MenuItem value="" disabled>
              None
            </MenuItem>

            {sequenceList.map((seq) => (
              <MenuItem key={seq.id} value={seq.id}>
                {seq.code || seq.name}
              </MenuItem>
            ))}
          </Select>
        )}
      </Box>

      {/* Shot Name Input */}
      <Typography sx={{ fontSize: 14, color: "#606479" }}>
        Shot Name:
      </Typography>

      <TextField
        fullWidth
        placeholder="Enter shot name"
        variant="outlined"
        size="small"
        value={shotName}
        onChange={(e) => setShotName(e.target.value)}
        sx={{
          "& .MuiOutlinedInput-root": {
            height: "41px",
            background: "#252A38",
            borderRadius: "10px",
            fontFamily: "Poppins",
            fontSize: "14px",
            color: "#F9F9F9",

            "& fieldset": {
              border: "none",
            },

            "&:hover fieldset": {
              border: "none",
            },

            "&.Mui-focused fieldset": {
              border: "none",
            },
          },

          "& .MuiInputBase-input": {
            padding: "10px 8px 10px 10px",
            color: "#F9F9F9",
          },

          "& input::placeholder": {
            color: "#606479",
            opacity: 1,
          },
        }}
      />

      {/* Create Shot Button */}
      <Button
        fullWidth
        onClick={isBulkMove ? handleBulkMove : createShot}
        disabled={creating || !selectedSequence}
        sx={{
          height: "41px",
          background: "#6C65D9",

          borderRadius: "10px",
          fontSize: "14px",
          fontWeight: 400,
          color: "#EEEEEE",
          textTransform: "none",

          "&:hover": {
            background: "#2F3445",
          },
          "&:disabled": {
            background: "#252A38",
          },
        }}
      >
        {creating ? "Creating..." : "Create Shot"}
      </Button>
    </Box>
  );
};

export default MoveReviewVersionToShotModal;
